import {
  BridgeConnectOptions,
  BridgeConnectInstance,
} from '../types';

interface ManagerState {
  bridge: BridgeConnectInstance | null;
  open: boolean;
}

export const createBridge = (
  config: BridgeConnectOptions,
  creator: (config: BridgeConnectOptions) => BridgeConnectInstance
) => {
  const state: ManagerState = {
    bridge: null,
    open: false,
  };

  if (typeof window === 'undefined') {
    throw new Error('BridgeConnect is not loaded');
  }

  state.bridge = creator({
    ...config,
    onExit: () => {
      state.open = false;
      config.onExit && config.onExit();
    },
  });

  const open = () => {
    if (!state.bridge) {
      return;
    }
    
    state.open = true;
    state.bridge.open();
  };

  const destroy = () => {
    if (!state.bridge) {
      return;
    }

    state.bridge.destroy();
    state.bridge = null;
  };

  return {
    open,
    destroy,
  };
};